<ng-container *ngIf="customerServiceSection$ | async as customerServiceSection">
  <div class="customer-service-section" *ngIf="!isMobile" (clickOutside)="refreshSelectedClass()">
    <h2>{{ customerServiceSection.title }}</h2>

    <mat-nav-list *ngIf="customerServiceSectionData$ | async as customerServiceSectionData">
      <a
        mat-list-item
        disableRipple
        [class.selected]="customerServiceSectionActive === link.uid"
        *ngFor="let link of customerServiceSectionData; let i = index"
        (click)="onClickCustomerServiceSectionLink(link, i); activeI = i"
      >
        {{ link.title ? link.title : link.linkName }}
      </a>
    </mat-nav-list>
  </div>
</ng-container>
